module.exports = __webpack_public_path__ + "resources/img/hr-logo@3x.75738e35.png";